<template>
  <NotifyBar :notify="notify" />
</template>

<script>
import { mapState } from 'vuex';
import NotifyBar from './NotifyBar.vue';
export default {
  components: {
    NotifyBar
  },
  computed: mapState('notify', ['notify'])
};
</script>
